export default __webpack_public_path__ + "static/media/whats_pc@2x.43b9588c.jpg";